import { COMING_SOON } from "../data/catalog";
import { MaskLines } from "../components/site/Reveal";
import { ComingSoonCard } from "../components/home/ComingSoonCard";
import { Newsletter } from "../components/site/Newsletter";

export default function ComingSoonPage() {
  return (
    <div className="bg-ivory pt-36 md:pt-44" data-testid="coming-soon-page">
      <div className="mx-auto max-w-[1600px] px-5 pb-24 md:px-10">
        <p className="label-mono">Coming soon · {COMING_SOON.length} new categories</p>
        <MaskLines as="h1" lines={["The next", <em key="n">chapter.</em>]} className="mt-3 font-display text-5xl font-light leading-none text-ink md:text-8xl" />
        <p className="mt-5 max-w-lg text-sm leading-relaxed text-graphite">
          MARKHOR is growing beyond bags. Men's and women's shoes, traditional footwear, polo shirts, trousers and luggage are in the works. Join the list to hear first when each one launches.
        </p>
        <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {COMING_SOON.map((item, i) => (
            <ComingSoonCard key={item.id} item={item} delay={(i % 3) * 0.06} className={`min-h-[460px] ${i === 0 ? "sm:col-span-2 lg:col-span-2" : ""} ${i === COMING_SOON.length - 1 ? "sm:col-span-2 lg:col-span-3" : ""}`} />
          ))}
        </div>
        <p className="mt-10 text-xs text-graphite">Images are concept visuals for upcoming categories and may differ from final products.</p>
      </div>
      <Newsletter />
    </div>
  );
}
